import { render, staticRenderFns } from "./FlawView.vue?vue&type=template&id=5cac6c4c&scoped=true"
import script from "./FlawView.vue?vue&type=script&lang=js"
export * from "./FlawView.vue?vue&type=script&lang=js"
import style0 from "./FlawView.vue?vue&type=style&index=0&id=5cac6c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac6c4c",
  null
  
)

export default component.exports